<template>
  <div v-wechat-title="titleTop">
    <TopBar :pagetitle="title" :back-url="backurl" />
    <div v-for="item in list" :key="item.organizationId" class="rect" @click="onClickDiveCenter(item)">
      <div class="title">
        {{ item.name }}
        <van-rate v-model="item.score" allow-half readonly size="1em" :color="GetDiveMainBack()" /><span v-if="item.score<=0" class="noScore">暂无评分</span>
      </div>
      <van-image
        width="100vw"
        height="50vw"
        :src="item.icon?item.icon:'/dive/defaultDiveCenter.jpg'"
        fit="cover"
      />
      <div class="about">
        <div>
          {{ item.about?item.about:'暂无介绍' }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import request from '@/utils/request'
import { Button, Image, Rate } from 'vant'
import TopBar from '@/components/TopBar'
import { ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { GetDiveMainBack, GetColorMain, GetColorSecondary, GetDiveTitle, GetColorMainLine } from '@/utils/base'
export default {
  components: {
    [Button.name]: Button,
    [Image.name]: Image,
    [Rate.name]: Rate,
    TopBar
  },
  data() {
    return {
      titleTop: '',
      title: '潜水中心列表',
      backurl: '/dive',
      list: [],
      loading: true
    }
  },

  created() {
    this.titleTop = GetDiveTitle()
    this.init()
  },
  methods: {
    ShowMoney,
    GetColorMainLine,
    GetDiveMainBack,
    GetColorMain,
    GetColorSecondary,
    GetDiveTitle,
    GetEnumText,
    formatDate,
    init() {
      request({
        url: '/DiveData/getDiveCenterList',
        method: 'post'
      }).then(response => {
        if (!response.success) {
          return
        }
        this.loading = false
        this.list = response.data
      })
    },
    onClickDiveCenter(item) {
      this.$router.push('/dive/diveCenter/' + item.organizationId)
    }
  }
}
</script>
<style scoped>
.rect{
  background-color: #fff;
margin-bottom: 0.5em;
}
.rect .title{
  width: 90vw;
  z-index: 1;
  color: #000;
  font-weight: 700;
  letter-spacing:2px;
  padding: 1em;
}
.rect .about{
  padding: 0.5em 1em;
  color: #999;

}
.rect .about div{
  overflow: hidden;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
  font-size: 0.8em;
}
.noScore{
    color: #999;
    font-size: 0.7em;
    margin-left: 0.5em;
    font-weight: 400;
}

</style>
